import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { useCurrentReflection } from '@/hooks'
import { useApiQuery } from '@/utils/use-api-query'
import { $t } from 'packages/locale'
import { FC, useContext } from 'react'

import { IndexBoardCard } from '../components/IndexBoardCard'
import { DataBoardContext } from '../context'
import { useStatsApiQuery } from '../utils/query'

/**
 * 处分统计卡片
 *
 * @returns 处分统计卡片
 */
export const PunishmentCard: FC = () => {
  const { semesterInfo, timeRange } = useContext(DataBoardContext)
  const reflection = useCurrentReflection()

  const apiQuery = useStatsApiQuery({
    timeRange,
    semesterInfo,
  })

  const { data: res, loading } = useApiQuery({
    apiName: 'queryAdvisorStudentCertificationStats',
    params: {
      query: apiQuery,
    },
    options: {
      enabled: !!reflection?.usin,
    },
  })

  const { data: certificationStats } = res || {}

  const getInfo = (name: string) =>
    certificationStats?.find((item) => item.name === name)

  return (
    <IndexBoardCard
      title={$t('处分统计')}
      count={certificationStats?.at(0)?.total_user_count ?? 0}
      items={[
        {
          label: $t('警告'),
          value: getInfo('警告')?.type_user_count ?? 0,
        },
        {
          label: $t('严重警告'),
          value: getInfo('严重警告')?.type_user_count ?? 0,
        },
        {
          label: $t('记过'),
          value: getInfo('记过')?.type_user_count ?? 0,
        },
        {
          label: $t('留校察看'),
          value: getInfo('留校察看')?.type_user_count ?? 0,
        },
      ]}
      flex={2}
      type={StatsDetailsTabEnum.StudentPunishment}
      loading={loading}
      itemIconMsg={{
        name: 'Siren',
        color: '#F54545',
        backgroundColor: '#FFECE8',
      }}
    />
  )
}
